const auth = {
  heading: 'FOR the Sport, BY the Sport.',
  signIn: 'Sign In',
  forgotPass: 'Forgot Password?',
  claimQuestion: 'Just in a tournament?',
  claimAccount: 'Claim Your Account',
  claimAccountDesc:
    'Already played in a tournament or a league? You may already have a player profile and a DUPR rating.',
  noAccount: "Don't have a DUPR account?",
  signUp: 'Sign Up',
  createAccount: 'Create Account',
  createPassword: 'Create Password',
  passInstructLength: 'Must be at least 6 characters long',
  passInstructStructure: 'Must contain one or more numbers',
  forgotPassDesc: 'Enter your registered email to receive instructions on how to reset your password.',
  checkYourEmail: 'Check Your Email!',
  // Deliberately non-committal: shown for every reset request, so it cannot reveal whether the
  // address has an account. Do not replace it with a server-supplied message.
  resetCodeSentGeneric: "If an account exists for that address, we've sent a 4-digit code.",
  verifyEmailDesc: 'You’ve just had a code to reset your password via email. Enter the 4 digit code to continue.',
  verifyYourNumber: 'Verify Your Number',
  verifyPhoneNumberDesc: 'A 4-digit code was sent to your phone number - enter it here to verify it.',
  claimAccountHelpText: 'Type your name in the search bar to begin searching for your results',
  notSeeYourself: 'Don’t see yourself here?',
  lastMatch: 'Last Match',
  noMatchResult: 'No match result.',
  accAlreadyTaken: 'This account is already taken',
  accAlreadyTakenModal:
    'If you believe this is you, and someone else has claimed your account, please contact our support team',
  iAgreeToThe: 'I agree to the',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  acceptTerms: 'Please accept the Terms of Service to continue',
  cookiePolicy: 'Cookie Policy',
}

export type LocaleAuth = typeof auth

export default auth
